import { Component } from "react";
import { connect, ConnectedComponent } from "react-redux";
import { IStore, TokenState } from "../../DataTypes/storeTypes";
import { onRegisterSubmit } from "../../Actions/actions";
import { Field, reduxForm, formValueSelector, clearFields } from "redux-form";
import {
    email,
    fixedLength6,
    maxLength30,
    minLength6,
    required,
    validatePhoneFormat,
    validatePhonePrefix,
} from "../../../Common/Form/formValidationRules";
import TextInput from "../../../Common/Form/TextInput";
import HiddenInput from "../../../Common/Form/HiddenInput";
import * as timeZoneUtils from "../../../Common/timeZoneUtils";
import { CountryCode } from "libphonenumber-js";
import { Button, Link } from "@powerdiary/components-library/lib";
import { Collapse } from "@mui/material";

interface IProps {
    isBusy: boolean;
    isSmsType: boolean;
    state: TokenState;
    termsAndConditions: string;
    countryCode: CountryCode;
    timeZoneIdIana: string;

    errorMessage: string;

    initialValues: any;
    onSubmit(values);
}

interface IFormProps extends IProps {
    passwordValue?: string;

    handleSubmit?: any;
}

interface IRegisterState {
    showTermsAndConditions: boolean;
}

class Register extends Component<IFormProps, IRegisterState> {
    constructor(props: IFormProps) {
        super(props);

        this.state = {
            showTermsAndConditions: false,
        };
    }
    validatePassword = (value: string) => {
        return value && value !== this.props.passwordValue
            ? "The password and confirmation password do not match."
            : undefined;
    };

    validatePhone = (value: string) => {
        if (!value) {
            return undefined;
        }

        return validatePhonePrefix(value, this.props.countryCode);
    };

    validatePhoneFormat = (value: string) => {
        if (!value) {
            return undefined;
        }

        return validatePhoneFormat(value, this.props.countryCode);
    };

    updateTermsAndConditions = () => {
        this.setState({ showTermsAndConditions: !this.state.showTermsAndConditions });
    };

    render() {
        return (
            <>
                <div className="row">
                    <div className="col-12">
                        <form onSubmit={this.props.handleSubmit}>
                            <Field name="timeZoneIdIana" type="text" component={HiddenInput} />
                            <div className="form-group row">
                                <label className="col-12 col-md-4 col-form-label">First name</label>
                                <div className="col-12 col-md-8">
                                    <Field name="firstName" type="text" component={TextInput} validate={[required]} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-12 col-md-4 col-form-label">Last name</label>
                                <div className="col-12 col-md-8">
                                    <Field name="lastName" type="text" component={TextInput} validate={[required]} />
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="col-12 col-md-4 col-form-label">Email</label>
                                <div className="col-12 col-md-8">
                                    <Field
                                        name="email"
                                        type="email"
                                        component={TextInput}
                                        validate={[required, email]}
                                    />
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="col-12 col-md-4 col-form-label">New Password</label>
                                <div className="col-12 col-md-8">
                                    <Field
                                        name="password"
                                        type="password"
                                        component={TextInput}
                                        validate={[required, minLength6, maxLength30]}
                                    />
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="col-12 col-md-4 col-form-label">Confirm New Password</label>
                                <div className="col-12 col-md-8">
                                    <Field
                                        name="confirmPassword"
                                        type="password"
                                        component={TextInput}
                                        validate={[required, this.validatePassword]}
                                    />
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="col-12 col-md-4 col-form-label">Mobile Number</label>
                                <div className="col-12 col-md-8">
                                    <Field
                                        name="phoneNumber"
                                        type="text"
                                        component={TextInput}
                                        validate={
                                            this.props.isSmsType
                                                ? [required, this.validatePhone]
                                                : [this.validatePhoneFormat]
                                        }
                                    />
                                </div>
                            </div>

                            {this.props.state === TokenState.ShowToken && (
                                <div className="form-group row">
                                    <label className="col-12 col-md-4 col-form-label">Verification code</label>
                                    <div className="col-12 col-md-8">
                                        <Field
                                            name="token"
                                            type="text"
                                            component={TextInput}
                                            validate={[required, fixedLength6]}
                                        />
                                        <small className="form-text text-muted">
                                            Please enter the activation code received.
                                        </small>
                                    </div>
                                </div>
                            )}

                            {this.props.state === TokenState.ShowToken && this.props.termsAndConditions && (
                                <div className="form-group row">
                                    <div className="col-12 mb-3">
                                        <div className="custom-checkbox">
                                            <Field
                                                name="conditions"
                                                type="checkbox"
                                                id="conditions"
                                                component={TextInput}
                                                validate={[required]}
                                            />
                                            <label className="form-check-label" htmlFor="conditions">
                                                I accept the{" "}
                                                <Link
                                                    variant="mediumRegular"
                                                    href="#"
                                                    onClick={() => this.updateTermsAndConditions()}
                                                >
                                                    terms and conditions of use
                                                </Link>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <Collapse
                                in={this.props.state === TokenState.ShowToken && this.state.showTermsAndConditions}
                            >
                                <div id="terms-and-Conditions">
                                    <div dangerouslySetInnerHTML={{ __html: this.props.termsAndConditions }} />
                                </div>
                            </Collapse>

                            {this.props.errorMessage && (
                                <div className="alert alert-danger" role="alert">
                                    <div>{this.props.errorMessage}</div>
                                </div>
                            )}

                            <div className="row mt-4">
                                <div className="col text-center">
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        size="large"
                                        className="btn-block"
                                        disabled={this.props.isBusy}
                                    >
                                        {this.props.state === TokenState.Initial ? "Get verification code" : "Submit"}
                                    </Button>
                                    {this.props.state === TokenState.Initial && (
                                        <small className="text-muted">
                                            {`A verification code will be sent to your ${this.props.isSmsType ? "mobile number" : "email"}.`}
                                        </small>
                                    )}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </>
        );
    }
}

const FormConnected = reduxForm({ form: "recoverForm", getFormState: (state: IStore) => state.forms.recoverForm })(
    Register
);

const selector = formValueSelector("recoverForm", (state: IStore) => state.forms.recoverForm);

const mapStateToProps = (state: IStore, ownProps: IFormProps): IFormProps => {
    const passwordValue = selector(state, "password");

    const isSmsType = state.initialSettings.organisationInfo.tokenVia === "sms";

    const initialValues = {
        timeZoneIdIana: timeZoneUtils.getUserTimeZoneId(),
    };

    return {
        ...ownProps,
        initialValues: initialValues,
        passwordValue: passwordValue,
        state: state.common.registerPageState,
        isBusy: state.common.isBusy,
        isSmsType: isSmsType,
        errorMessage: state.common.errorMessage,
        countryCode: state.initialSettings.organisationInfo.countryCode,
        termsAndConditions: state.initialSettings.organisationInfo.termsAndConditions,
    };
};

const mapDispatchToProps = (dispatch, ownProps: IProps): IProps => {
    return {
        ...ownProps,
        onSubmit: (values) => {
            dispatch(
                onRegisterSubmit(values, () => {
                    dispatch(clearFields("recoverForm", false, true, "token"));
                })
            );
        },
    };
};

export const RegisterConnected: ConnectedComponent<typeof FormConnected, any> = connect(
    mapStateToProps,
    mapDispatchToProps
)(FormConnected);
